import {Box, ToggleButtonGroup, Typography} from '@mui/material';
import React from 'react';
import HeliosToggleButton from './HeliosToggleButton';
import {OVERLINE_LABEL_SX} from '../../styles';

export interface ToggleFilterOption<T extends string> {
  value: T;
  label: string;
}

interface Props<T extends string> {
  label: string;
  options: ToggleFilterOption<T>[];
  value: T;
  onChange: (value: T) => void;
}

/**
 * A labelled, single-select row of Helios toggle buttons. The group is
 * exclusive and ignores a null change, so a filter can never be cleared into
 * an undefined state by clicking the active option.
 */
const HeliosToggleFilter = <T extends string>({
  label,
  options,
  value,
  onChange,
}: Props<T>) => (
  <Box>
    <Typography sx={{...OVERLINE_LABEL_SX, fontSize: 10, mb: 0.5}}>
      {label}
    </Typography>
    <ToggleButtonGroup
      exclusive
      size="small"
      value={value}
      onChange={(_, next) => next && onChange(next as T)}>
      {options.map(option => (
        <HeliosToggleButton
          key={option.value}
          value={option.value}
          sx={{textTransform: 'none'}}>
          {option.label}
        </HeliosToggleButton>
      ))}
    </ToggleButtonGroup>
  </Box>
);

export default HeliosToggleFilter;
